/**
 * Get a trailing-slash-terminated root URL for the Shopify storefront.
 * This is used to construct URLs for API calls and asset loading.
 *
 * The root URL is derived from the `data-root` attribute on the document's root element. If the attribute is not set, it defaults to an empty string. The function ensures that the returned URL always ends with a slash, which is important for consistent URL construction throughout the application.
 */
export function getShopifyRootUrl(): string {
	const root = document.documentElement.dataset.root || "";
	if (root.endsWith("/")) {
		return root;
	}

	return `${root}/`;
}

export function resolveShopifyUrl(...segments: string[]): string {
	const root = getShopifyRootUrl();
	const url = new URL(globalThis.location.href);
	url.pathname = root;
	segments.forEach((segment) => {
		url.pathname = `${url.pathname.replace(/\/$/, "")}/${segment.replace(/^\//, "")}`;
	});
	return url.toString();
}
